import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant15PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 1264 1016",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M70.8652 933.4C165.845 932.551 262.657 963.466 355.225 930.183C425.499 904.941 477.368 834.845 465.752 757.914C453.556 676.828 378.635 610.262 384.979 528.505C390.25 460.911 454.36 408.418 521.507 398.947C588.654 389.475 656.338 414.851 714.237 450.1C772.137 485.349 823.469 530.561 880.654 566.971C933.594 600.656 996.676 627.283 1057.88 613.434C1117.08 600.076 1163.45 549.324 1182.03 491.514C1200.57 433.704 1194.28 370.265 1175.6 312.499C1148.13 227.437 1099.88 142.018 1047.16 70.3135",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant15PathwayIllustration as default };
